var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "204.000000pt",
    height: "192.000000pt",
    viewBox: "0 0 204.000000 192.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,192.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1742 1864 c-56 -29 -87 -98 -70 -159 7 -28 2 -36 -98 -136 l-105 -106 -53 5 c-63 5 -110 -15 -134 -59 l-17 -29 -445 0 -446 0 -18 31 c-45 77 -185 78 -240 2 -29 -39 -32 -111 -7 -151 57 -90 173 -96 244 -12 l26 30 444 0 444 0 12 -23 c6 -12 25 -31 41 -42 l30 -20 0 -443 0 -442 -46 -45 -46 -44 4 -62 c4 -56 8 -65 40 -95 39 -35 91 -50 134 -40 14 4 44 24 66 44 32 31 41 46 45 82 5 55 -19 106 -65 135 l-31 20 -1 445 0 445 29 17 c46 26 66 64 66 129 l0 58 102 103 c100 102 102 104 142 100 55 -5 83 3 120 34 64 54 62 160 -5 210 -44 34 -115 42 -162 18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetbox);
export default __webpack_public_path__ + "static/media/netbox.b6954091bc790a034847fa946e220bc3.svg";
export { ForwardRef as ReactComponent };